import { observer } from "mobx-react-lite";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import { RESOLUTION_CATEGORY } from "../../../../../../../models/ResolutionTypes";
import { INSTANT_REFUND_PROVIDER_IMAGE_MAP, VOUCHER_TYPE_MAP } from "../../../../../constants";
import { ResolutionLineItemProps } from "../resolution-line";
import './resolution-line-item-type.scss';



const ResolutionLineItemType: React.FC<ResolutionLineItemProps>  = observer(({ category, resolution }) => {
    // cancel order resolutions do not have types
    if (category === RESOLUTION_CATEGORY.cancel_order_resolutions) {
        return <></>;
    }

    const getItemTypeTitle = () => {
        if (category === RESOLUTION_CATEGORY.exchange_resolutions) {
            return 'Exchange Type';
        }
        return 'Resolution Type';
    }

    const getItemProviderIcon = () => {
        if (resolution.instantRefundProvider) {
            return <img src={INSTANT_REFUND_PROVIDER_IMAGE_MAP[resolution.instantRefundProvider]} width="16" height="16" alt=""/>;
        }
        return <></>;
    }

    const getItemTypeValue = () => {
        // for retungo resolutions we return voucher type
        if (category === RESOLUTION_CATEGORY.returngo_resolutions) {
            return VOUCHER_TYPE_MAP[resolution.voucherType]?.label;
        }

        return resolution.getResolutionTypeName();
    }

    return (
        <>
            <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>
                { getItemTypeTitle() }
            </FontBody3>
            <div className="item-type-value">
                { getItemProviderIcon() }
                <FontBody3 color={FONT_COLOR.PRIMARY3_50}>
                    { getItemTypeValue() }
                </FontBody3>
            </div>
            
        </>
    );
});

export default ResolutionLineItemType;